<template>
    <div class="contactMap_1">
            <el-amap vid="amap"  class="amap" :center="center" :zoom="zoom"  :lang="lang">
                <el-amap-marker :position="center" vid="amapMarker"></el-amap-marker>
            </el-amap>
    </div>
</template>

<script>

import Vue from 'vue'
import VueAMap from 'vue-amap'; // 高德
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '4a126cedac4791580af7c67d0138d581',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});

export default {
    components:{
        
    },
    data () {
        let self = this;
        return {
            center: [24.9,50.6], // 高德地图中心点
            zoom: 6, // 地图缩放
            lang:"en",
            isZhong:false
        };
    },
     created(){
       const language = this.$cookies.get('language');
       let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong; 

        let lang = "";
         if(isZhong){
           lang="cn"
        }else{
           lang="en"
            
        }
        this.lang = lang;

     }
    
};
</script>

<style lang="scss" scoped>
@import '../../common/css/mixin.scss';
.amap{
    width: 100%;
    height: 450px;
}

@media (max-width:767px) {
    .amap{
        height: 222px;
    }
        
}
</style>


// WEBPACK FOOTER //
// src/components/BaiduMap/BaiduMap.vue